const REST_PROMOTE_ALL_ALLOWED = {
    rest: true,
    random: true,
    labor: true,
    emailStatus: true,
    restSend: true,
    randomSend: true,
};

export const getRestPromote = (userMe) => (
    userMe?.roleName === '대표 관리자'
        ? REST_PROMOTE_ALL_ALLOWED
        : (userMe?.permissions?.detailRole?.restPromote || {})
);

/**
 * Tab configuration for Promotion Target
 * @param {Function} t - Translation function
 * @returns {Array} - Array of tab objects
 */
export const getTabsConfig = (t, restPromote) => [
    {
        key: 'rest',
        label: t('annualLeavePromotion.annualLeaveUsagePromotion'),
        name: 'annualLeaveUsagePromotion'
    },
    {
        key: 'random',
        label: t('annualLeavePromotion.randomAssignment'),
        name: 'randomAssignment'
    },
    {
        key: 'labor',
        label: t('annualLeavePromotion.laborRefusalNotification'),
        name: 'laborRefusalNotification'
    },
    {
        key: 'emailStatus',
        label: t('annualLeavePromotion.emailSendStatus'),
        name: 'emailSendStatus'
    }
].filter((tab) => !restPromote || !!restPromote[tab.key]);

// Get status badge color for send/receipt status
export const getStatusBadgeColor = (status) => {
  switch (status) {
    case 'SEND':
      return { backgroundColor: '#F2EFFF', color: '#7156EE' };
    case 'READ':
      return { backgroundColor: '#E8F5E8', color: '#4CAF50' };
    case 'UNREAD':
      return { backgroundColor: '#FFEBEE', color: '#F44336' };
    default:
      return { backgroundColor: '#F5F5F5', color: '#666666' };
  }
};

// Get status text for send/receipt status
export const getStatusText = (status, t) => {
  switch (status) {
    case 'SEND':
      return t('annualLeavePromotion.sent');
    case 'READ':
      return t('annualLeavePromotion.read');
    case 'UNREAD':
      return t('annualLeavePromotion.unread');
    default:
      return status;
  }
};

// Configuration for dynamic search fields based on selected tab
export const getSearchFieldsConfig = (t, commCodeList) => {
    // Common fields that appear on all tabs
    const commonFields = [
        {
            name: 'selectedYear',
            type: 'select',
            placeholder: t('annualLeavePromotion.year'),
            options: (year) => year?.map((index, key) => ({
                key,
                value: index,
                label: `${index} ${t('annualLeavePromotion.year')}`
            })),
            onChange: 'setSelectedYear',
            fieldName: 'yearSelect'
        },
        {
            name: 'searchUser',
            type: 'input',
            placeholder: t('approval.searchPlaceholder'),
            onChange: 'setSearchUser',
            fieldName: 'searchUserInput'
        }
        /*
        {
          name: 'employType',
          type: 'select',
          placeholder: t('annualLeavePromotion.selectEmployeeType'),
          options: () => [{ value: '', label: t('annualLeavePromotion.all') }, ...employList],
          onChange: 'setEmployType',
          fieldName: 'employTypeSelect'
        },
        {
          name: 'workPlace',
          type: 'select',
          placeholder: t('annualLeavePromotion.workplace'),
          options: () => [{ value: '', label: t('annualLeavePromotion.all') }, ...workPlaceList],
          onChange: 'setWorkPlace',
          fieldName: 'workPlaceSelect'
        }
        */
    ];

    // Tab-specific fields - object with field names as keys
    const tabSpecificFields = {
        // Rest tab specific fields
        receiptStatus: {
            name: 'receiptStatus',
            type: 'select',
            placeholder: t('annualLeavePromotion.receiptStatus'),
            options: () => [
                { value: '', label: t('annualLeavePromotion.all') },
                { value: 'received', label: t('annualLeavePromotion.received') },
                { value: 'notReceived', label: t('annualLeavePromotion.notReceived') }
            ],
            onChange: 'setReceiptStatus',
            fieldName: 'receiptStatusSelect',
        },
        // Rest tab specific fields
        agreeStatus: {
            name: 'agreeStatus',
            type: 'select',
            placeholder: t('annualLeavePromotion.agreeStatus'),
            options: () => [
                { value: '', label: t('annualLeavePromotion.all') },
                { value: 'received', label: t('annualLeavePromotion.agreed') },
                { value: 'notReceived', label: t('annualLeavePromotion.notAgreed') }
            ],
            onChange: 'setAgreeStatus',
            fieldName: 'agreeStatusSelect',
        },
        annualLeavePlanStatus: {
            name: 'annualLeavePlanStatus',
            type: 'select',
            placeholder: t('annualLeavePromotion.annualLeavePlanStatus'),
            options: () => [
                { value: '', label: t('annualLeavePromotion.all') },
                { value: 'SUCCESS', label: t('userVacation.approve') },
                { value: 'REQUEST', label: t('annualLeavePromotion.requested') },
                { value: 'REJECT', label: t('반려') },
                { value: 'NONE', label: t('annualLeavePromotion.notRequest') },
            ],
            onChange: 'setAnnualLeavePlanStatus',
            fieldName: 'annualLeavePlanStatusSelect',
        },
        targetEmployee: {
            name: 'targetEmployee',
            type: 'select',
            placeholder: t('annualLeavePromotion.targetEmployee'),
            options: () => commCodeList,
            onChange: 'setTargetEmployee',
            fieldName: 'targetEmployeeSelect',
        },
        sendStatus: {
            name: 'sendStatus',
            type: 'select',
            placeholder: t('annualLeavePromotion.sendStatus'),
            options: () => [
                { value: '', label: t('annualLeavePromotion.all') },
                { value: 'SEND', label: t('annualLeavePromotion.sent') },
                { value: 'FAIL', label: t('annualLeavePromotion.failed') },
                { value: 'WAIT', label: t('annualLeavePromotion.waiting') }
            ],
            onChange: 'setSendStatus',
            fieldName: 'sendStatusSelect',
        },
        emailType: {
            name: 'emailType',
            type: 'select',
            placeholder: t('annualLeavePromotion.emailType'),
            options: () => [
                { value: '', label: t('annualLeavePromotion.all') },
                { value: 'ANN_VAC_PROM', label: t('annualLeavePromotion.ANN_VAC_PROM') },
                { value: 'ANN_VAC_DUE_PROM', label: t('annualLeavePromotion.ANN_VAC_DUE_PROM') },
                { value: 'ANN_VAC_THIRD_PROM', label: t('annualLeavePromotion.ANN_VAC_THIRD_PROM') },
                { value: 'NO_SENT', label: t('annualLeavePromotion.notSent') },
            ],
            onChange: 'setEmailType',
            fieldName: 'emailTypeSelect',
        },
        emailType2: {
            name: 'emailType',
            type: 'select',
            placeholder: t('annualLeavePromotion.emailType'),
            options: () => [
                { value: '', label: t('annualLeavePromotion.all') },
                { value: 'ANN_VAC_PROM', label: t('annualLeavePromotion.ANN_VAC_PROM') },
                { value: 'ANN_VAC_DUE_PROM', label: t('annualLeavePromotion.ANN_VAC_DUE_PROM') },
                { value: 'ANN_VAC_THIRD_PROM', label: t('annualLeavePromotion.ANN_VAC_THIRD_PROM') },
                { value: 'RANDOM_ASSIGNMENT_LEAVE_PLAN', label: t('annualLeavePromotion.RANDOM_ASSIGNMENT_LEAVE_PLAN') },
                { value: 'CONFIRM_NOTICE_OF_REFUSAL_TO_RECEIVE_LABOR', label: t('annualLeavePromotion.CONFIRM_NOTICE_OF_REFUSAL_TO_RECEIVE_LABOR') },
                /*{ value: 'VACATION_REQUEST_APPROVAL', label: t('annualLeavePromotion.VACATION_REQUEST_APPROVAL') },*/
            ],
            onChange: 'setEmailType',
            fieldName: 'emailTypeSelect',
        },
        workStatus: {
            name: 'workStatus',
            type: 'select',
            placeholder: t('memberList.selectWorkStatus'),
            options: () => [
                { value: '', label: t('common.label.all') },
                { value: 'SUCCESS', label: t('filters.employment') },
                { value: 'LEAVE', label: t('퇴직') },
                { value: 'REST', label: t('filters.leaveOfAbsence') },
                { value: 'SUSPENSION', label: t('정직(징계)') }
            ],
            onChange: 'setWorkStatus',
            fieldName: 'workStatus',
        },
        remainingType : {
            name: 'remainingType',
            type: 'select',
            placeholder: t('annualLeavePromotion.selectRemainingType'),
            options: () => [
                { value: '', label: t('annualLeavePromotion.all') },
                { value: 'annual', label: t('annualLeavePromotion.annual') },
                { value: 'monthly', label: t('annualLeavePromotion.monthly') },
                { value: 'carryOver', label: t('annualLeavePromotion.carryOver') },
            ],
            onChange: 'setRemainingType',
            fieldName: 'remainingTypeSelect'
        }
    };

    return {
        commonFields,
        tabSpecificFields
    };
};

/**
 * Extract replaceData fields and map them to specific fields
 * @param {string} replaceDataString - JSON string containing replaceData
 * @returns {Object} - Mapped fields object
 */
export const extractReplaceDataFields = (replaceDataString) => {
    if (!replaceDataString || typeof replaceDataString !== 'string') {
        return {
            targetVacation: '-',
            remainingVacation: '-',
            planningPeriod: '-',
            restTerm: '-',
            confirmationDateTime: '-',
            leftRestCnt: '-',
            recipient: '-'
        };
    }

    try {
        const replaceDataArray = JSON.parse(replaceDataString) || [];

        if (replaceDataArray?.length) {
            // Helper function to find value by key
            const findValueByKey = (key) => {
                const item = replaceDataArray.find(item => item.key === key);
                return item ? item.val : '-';
            };

            // Extract specific fields
            const targetVacation = findValueByKey('EMAIL_OPTION');
            const startDate = findValueByKey('START_DATE');
            const dueDate = findValueByKey('DUE_DATE');
            const restTerm = findValueByKey('REST_TERM');
            const confirmationDateTime = findValueByKey('CONFIRM_DATE');
            const leftRestCnt = findValueByKey('LEFT_REST_CNT');
            const recipient = findValueByKey('USER_NAME');

            // Format planning period
            let planningPeriod = '-';
            if (startDate !== '-' && dueDate !== '-') {
                planningPeriod = `${startDate} ~ ${dueDate}`;
            }

            return {
                targetVacation,
                planningPeriod,
                restTerm,
                confirmationDateTime,
                leftRestCnt,
                recipient
            };
        }
        return {
            targetVacation: '-',
            remainingVacation: '-',
            planningPeriod: '-',
            restTerm: '-',
            confirmationDateTime: '-',
            leftRestCnt: '-',
            recipient: '-'
        };

    } catch (error) {
        console.error('Error parsing replaceData:', error);
        return {
            targetVacation: '-',
            remainingVacation: '-',
            planningPeriod: '-',
            restTerm: '-',
            confirmationDateTime: '-',
            leftRestCnt: '-',
            recipient: '-'
        };
    }
};

/**
 * Process data array to extract replaceData fields for each item
 * @param {Array} dataArray - Array of data items
 * @returns {Array} - Processed data array with extracted fields
 */
export const processDataWithReplaceDataFields = (dataArray) => {
    if (!Array.isArray(dataArray)) {
        return [];
    }

    return dataArray.map(item => {
        const extractedFields = extractReplaceDataFields(item.replaceData);

        return {
            ...extractedFields,
            ...item,
        };
    });
};

const SEND_COLUMNS_BY_TAB = {
    rest: ['checkbox', 'sendIndividual'],
    random: ['checkbox', 'sendAssignment'],
};

/**
 * Column data configurations by tab (curried)
 * Usage: getColumnsList(t)('rest' | 'random' | 'labor')
 */
export const getColumnsList = (t) => (tabName, canSend = true) => {
    const byTab = {
        rest: [
            { grow: 1, width: 230, name: t('annualLeavePromotion.name'), key1: 'userInfo' },
            { grow: 1, width: 50, name: '', key1: 'checkbox' },
            { grow: 1, width: 150, name: t('annualLeavePromotion.joinDate'), key1: 'joinDate' },
            // { grow: 1, width: 200, name: t('annualLeavePromotion.standard'), key1: 'restType' },
            { grow: 1, width: 120, name: t('annualLeavePromotion.remainingVacation'), key1: 'remainingVacation' },
            { grow: 1, width: 100, name: t('annualLeavePromotion.annual'), key1: 'remainingRest' },
            { grow: 1, width: 100, name: t('annualLeavePromotion.monthly'), key1: 'remainingMonth' },
            { grow: 1, width: 100, name: t('annualLeavePromotion.carryOver'), key1: 'remainingCarryOver' },
            { grow: 1, width: 120, name: t('annualLeavePromotion.annualLeavePlanStatus'), key1: 'reqState' },
            { grow: 1, width: 150, name: t('annualLeavePromotion.emailType'), key1: 'emailType' },
            { grow: 1, width: 150, name: t('annualLeavePromotion.targetVacationShort'), key1: 'targetVacation' },
            { grow: 1, width: 150, name: t('annualLeavePromotion.sendDateTime'), key1: 'sendAt' },
            { grow: 1, width: 100, name: t('annualLeavePromotion.sendMail'), key1: 'sendIndividual' },
            { grow: 1, width: 150, name: t('annualLeavePromotion.details'), key1: 'emailSendHistory' },
        ],
        random: [
            { grow: 1, width: 230, name: t('annualLeavePromotion.name'), key1: 'userInfo' },
            { grow: 1, width: 50, name: '', key1: 'checkbox' },
            { grow: 1, width: 150, name: t('annualLeavePromotion.joinDate'), key1: 'joinDate' },
            // { grow: 1, width: 200, name: t('annualLeavePromotion.standard'), key1: 'restType' },
            { grow: 1, width: 120, name: t('annualLeavePromotion.remainingVacation'), key1: 'remainingVacation' },
            { grow: 1, width: 100, name: t('annualLeavePromotion.annual'), key1: 'remainingRest' },
            { grow: 1, width: 100, name: t('annualLeavePromotion.monthly'), key1: 'remainingMonth' },
            { grow: 1, width: 100, name: t('annualLeavePromotion.carryOver'), key1: 'remainingCarryOver' },
            { grow: 1, width: 120, name: t('annualLeavePromotion.annualLeavePlanStatus'), key1: 'reqState' },
            { grow: 1, width: 120, name: t('annualLeavePromotion.joinYearPeriod'), key1: 'joinYearPeriod' },
            { grow: 1, width: 120, name: t('annualLeavePromotion.baseYearEndPeriod'), key1: 'baseYearEndPeriod' },
            { grow: 1, width: 150, name: t('annualLeavePromotion.targetVacationShort'), key1: 'targetVacation' },
            { grow: 1, width: 150, name: t('annualLeavePromotion.designationDateTime'), key1: 'sendAt' },
            { grow: 1, width: 100, name: t('annualLeavePromotion.sendAssignment'), key1: 'sendAssignment' },
            { grow: 1, width: 150, name: t('annualLeavePromotion.details'), key1: 'emailSendHistory' },
        ],
        labor: [
            { grow: 1, width: 230, name: t('annualLeavePromotion.name'), key1: 'userInfo' },
            { grow: 1, width: 150, name: t('annualLeavePromotion.joinDate'), key1: 'joinDate' },
            { grow: 1, width: 240, name: t('annualLeavePromotion.date'), key1: 'restTerm' },
            { grow: 1, width: 150, name: t('workType.timeSetting'), key1: 'cutOffTime' },
            { grow: 1, width: 100, name: t('annualLeavePromotion.vacationStatus'), key1: 'reqState' },
            { grow: 1, width: 150, name: t('annualLeavePromotion.vacationModificationDateTime'), key1: 'reqUpdatedAt' },
            { grow: 1, width: 100, name: t('annualLeavePromotion.sendStatus'), key1: 'state' },
            { grow: 1, width: 150, name: t('annualLeavePromotion.sendDateTime'), key1: 'sendAt' },
            { grow: 1, width: 150, name: t('annualLeavePromotion.agreeDateTimeShort'), key1: 'opendAt' },
            { grow: 1, width: 150, name: t('annualLeavePromotion.details'), key1: 'emailSendHistory' },
            /*
            { grow: 1, width: 100, name: t('annualLeavePromotion.sendStatus'), key1: 'state' },
            { grow: 1, width: 150, name: t('annualLeavePromotion.vacationCreationDateTime'), key1: 'reqCreatedAt' },
            */
        ],
        emailStatus: [
            { grow: 1, width: 230, name: t('annualLeavePromotion.name'), key1: 'userInfo' },
            { grow: 1, width: 250, name: t('annualLeavePromotion.emailType'), key1: 'emailType' },
            { grow: 1, width: 150, name: t('annualLeavePromotion.targetVacationShort'), key1: 'targetVacation' },
            /*{ grow: 1, width: 150, name: t('annualLeavePromotion.recipient'), key1: 'recipient' },*/
            { grow: 1, width: 100, name: t('annualLeavePromotion.sendStatus'), key1: 'state' },
            { grow: 1, width: 150, name: t('annualLeavePromotion.sendDateTime'), key1: 'sendAt' },
            { grow: 1, width: 100, name: t('annualLeavePromotion.receiptStatus'), key1: 'isOpen' },
            { grow: 1, width: 150, name: t('annualLeavePromotion.receiptDateTime'), key1: 'opendAt' },
        ],
    };

    const columns = byTab[tabName] || [];

    if (canSend) {
        return columns;
    }

    const hiddenKeys = SEND_COLUMNS_BY_TAB[tabName] || [];
    return columns.filter((column) => !hiddenKeys.includes(column.key1));
};
